import { BehaviorSubject, Subscription } from 'rxjs';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { serverurl } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { SnackService } from './snack.service';
import { AppdataService } from './appdata.service';
import { Router } from '@angular/router';
import { ReportService } from './report.service';
import { AiService } from './ai.service';
import { UserdataService } from './userdata.service';

@Injectable({
  providedIn: 'root'
})
export class StreamService implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  userTrackData = new BehaviorSubject<any[]>([]);
  currentTrackData = new BehaviorSubject<any>(null);
  currentStepData = new BehaviorSubject<any>(null);
  currentRoundId: string = "";
  trackHistory = new BehaviorSubject<any[]>([]);
  trackResults = new BehaviorSubject<any[]>([]);
  trackFileResults = new BehaviorSubject<any[]>([]);
  currentProjectId: string = ""

  currentStepId = new BehaviorSubject<string>('');
  prevStepIndex: number = 0;
  currentStreamId = new BehaviorSubject<string>('');

  aiService: AiService = inject(AiService)
  userData = inject(UserdataService)

  constructor(
    private http: HttpClient,
    private appData: AppdataService,
    private snack: SnackService,
    private report: ReportService,
    private router: Router
  ) {

  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  async getClosingOptionsByStreamId(streamId: string): Promise<any[] | false> {
    return new Promise((resolve) => {
      let date = new Date().getTime();
      this.http.get(serverurl + `/aiservice/closingoptions/${streamId}?t=${date}`).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }
      });
    });
  }
  async downloadTrackResultFile(roundId: string, fileId: string, fileName: string,) {
    // ToDo: Delete with new TrackRun
    return new Promise((resolve) => {
      let date = new Date().getTime();
      this.http.get(`${serverurl}/knowledgehub/trackresult/${roundId}/${fileId}/${fileName}?t=${date}`, { responseType: 'blob' }).subscribe({
        next: async (data: any) => {
          this.report.saveReport(this.currentRoundId, 'DownloadFile');
          const blob = new Blob([data], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          resolve(true);
        },
        error: (err) => {
          this.snack.error(err);
          resolve(false);
        }

      });
    });
  }





}
